import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";

interface StatusOption {
  value: string;
  label: string;
}

interface StatusFilterProps {
  value: string;
  onChange: (value: string) => void;
  options: readonly StatusOption[];
  /** フィルターのラベル（デフォルト: "ステータス"） */
  label?: string;
  /** Select の labelId に使用する一意な識別子 */
  labelId?: string;
}

/**
 * ステータスフィルター
 * 一覧画面でステータスによるサーバーサイドフィルタリングを行うセレクトボックス
 */
export const StatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  options,
  label = "ステータス",
  labelId = "status-filter-label",
}) => {
  const handleChange = (event: SelectChangeEvent): void => {
    onChange(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value}
        label={label}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
